<script setup lang="ts">
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import tabviewStyle2 from '@/presets/lara/tabview/tabviewStyle2'
import YarnUsedTable from '@/components/features/productSpecification/YarnUsedTable.vue'
import StitchLengthTable from '@/components/features/productSpecification/StitchLengthTable.vue'
import KnittingSetOutTable from '@/components/features/productSpecification/KnittingSetOutTable.vue'
import YarnSetOutTable from '@/components/features/productSpecification/YarnSetOutTable.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'


import type { YarnSetOut, Weight, KnittingSetOut } from '@/types/product-types'

const props = defineProps<{
  knittingOut: KnittingSetOut[]
  yarnSetOut: YarnSetOut[]
}>()

const router = useRouter()

const yarnSetOutState = ref<YarnSetOut[]>([...props.yarnSetOut])

</script>

<template>
  <TabView class="bg-white" :pt="tabviewStyle2" :pt-options="{ mergeProps: false, mergeSections: false }">
    <TabPanel header="Yarn Used">
      <YarnUsedTable />
    </TabPanel>

    <TabPanel header="Stitch Lengths">
      <StitchLengthTable />
    </TabPanel>

    <TabPanel header="Knitting Set Out">
      <KnittingSetOutTable :knittingOut="knittingOut" />
    </TabPanel>

    <TabPanel header="Yarn Set Out">
      <YarnSetOutTable :yarnSetOut="yarnSetOutState" />
    </TabPanel>
  </TabView>
</template>

